'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
import createReactClass from 'create-react-class';
// Import JSX Modules
import Price from './price';
import ProgressButton from '../_utils/progress-button';
// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';
import translate from '../_utils/tools/translate';
import QuantityPricingTools from './quantity-pricing-tools';
import UrlBuilder from '../_utils/url-building';
import defaultOptionValue from './_common/default-option-value';

// -----------------------------------------------------------
//  PriceAndProductCreate
// -----------------------------------------------------------
var PriceAndProductCreate = createReactClass({
  render() {
    if (this.props.products.length === 0) return null;

    const { product, $price } = (() => {
      if (this.props.products.length === 1) {
        const [product] = this.props.products;

        return {
          product,
          $price: this.renderPrice(product, true),
        };
      }

      const product = this.productWithMinimumPrice();

      return {
        product,
        $price: this.renderPrice(product),
      };
    })();

    const action = this.action(product);

    return (
      <>
        <div className="row new-price-and-create d-flex justify-content-between"></div>
        <div
          className={classNames(
            'd-flex flex-column m-lg-3 mb-lg-4 p-3 p-lg-0',
            { 'price-and-create-mobile': this.isMobile() },
          )}>
          {this.renderCreateNow(action, $price)}
        </div>
      </>
    );
  },

  isMobile() {
    return this.props.viewPort === 'mobile';
  },
  isDesktop() {
    return this.props.viewPort === 'desktop';
  },
  renderCreateNow(action, price) {
    const { onClick } = this.props;

    const renderProgressButton = () => (
      <ProgressButton
        href={action}
        className="btn btn-primary btn-lg btn-block create-now"
        onClick={onClick}>
        {this.renderProgressButtonLabel(action)}
      </ProgressButton>
    );

    return (
      <>
        {/* Mobile view */}
        {this.isMobile() && (
          <div
            className="row price-and-create-mobile d-lg-none"
            data-test-id="mobile-price-section">
            <div className="col-6 col-lg-12 product-price">
              <div className="price">{price}</div>
            </div>
            <div className={classNames('col-6 col-lg-12 create-now')}>
              {renderProgressButton()}
            </div>
          </div>
        )}
        {/* Desktop view */}
        {this.isDesktop() && (
          <div
            className="d-none d-lg-block"
            data-test-id="desktop-price-section">
            <div className="product-price mb-3 align-self-baseline">
              <div className={classNames('price')}>{price}</div>
            </div>
            <div className="create-now">{renderProgressButton()}</div>
          </div>
        )}
      </>
    );
  },

  renderProgressButtonLabel(action) {
    return /^\/product\/add/.test(action)
      ? `Add to ${translate('Cart')}`
      : 'Create Now';
  },

  renderPrice(product, displayWas) {
    const { selectedDeliveryOptions, copies } = this.props;

    const deliveryKey = (() => {
      if (selectedDeliveryOptions !== null) {
        return parseInt(selectedDeliveryOptions, 10).toString();
      } else if (product.delivery_options.length === 1) {
        return product.delivery_options[0].toString();
      }
    })();

    const getDeliveryPrices = (deliveryKey) => {
      let prices = product.prices;
      const deliveryPrices =
        product.delivery_prices && product.delivery_prices[deliveryKey];
      if (deliveryPrices) {
        prices.prices.unit_prices = deliveryPrices.map(
          ({ break: from, price }) => ({
            from,
            price,
          }),
        );

        return prices;
      }
    };

    const unitPrices = (() => {
      getDeliveryPrices(deliveryKey) || product.prices;
    })();

    const { price, includeFrom } = (() => {
      const options = this.productOptions(product).filter(
        (option) => option.affectsPrice,
      );

      const showUnitPrice = !!this.props.showUnitPriceOnItemPages;

      if (options.length === 1) {
        const [option] = options;

        return {
          price: showUnitPrice ? option.minimumPrice : option.minimumPrice * copies,
          includeFrom: option.priceIsFrom,
        };
      }

      const price = (() => {
        const unitPrice = new QuantityPricingTools(product, unitPrices).getUnitPriceForQuantity(copies);
        return showUnitPrice ? unitPrice : unitPrice * copies;
      })();

      return {
        price,
        includeFrom: this.shouldDisplayFrom(),
      };
    })();

    const wasPrice = (() => {
      if (!displayWas) {
        return;
      }

      const wasPrice = (product.was_price || []).reduce((memo, wp) => {
        if (wp.quantity <= copies) {
          return this.props.showUnitPriceOnItemPages
            ? Object.assign({}, wp)
            : Object.assign({}, wp, { value: wp.value * copies });
        }

        return memo;
      }, {});

      if (genericHelpers.isWasPriceValid({ was_price: wasPrice, price })) {
        return wasPrice.value;
      }
    })();

    return (
      <Price
        now={price}
        was={wasPrice}
        includeFrom={includeFrom}
        displayWas={displayWas}
        showUnitPriceOnItemPages={this.props.showUnitPriceOnItemPages && !!product.show_quantity_dropdown}
      />
    );
  },

  shouldDisplayFrom() {
    const productPrice = this.props.products[0].minimum_price;
    for (let i = 0; i < this.props.products.length; i++) {
      let product = this.props.products[i];
      if (product.price_is_from || productPrice !== product.minimum_price) {
        return true;
      }
    }
    return false;
  },

  productWithMinimumPrice() {
    return this.props.products.reduce((memo, product) => {
      return memo.minimum_price < product.minimum_price ? memo : product;
    });
  },

  action(product) {
    // Determines the Create Now button action
    const params = {
      theme: this.props.theme,
      copies: this.props.copies,
    };

    if (this.props.variantName) {
      params.variant_name = this.props.variantName;
    }

    if (this.props.selectedDeliveryOptions) {
      const key = this.props.printsItemPage
        ? 'delivery'
        : 'selected_delivery_option';
      params[key] = this.props.selectedDeliveryOptions;
    }

    if (product.is_calendar && this.props.calendar_start_date) {
      const date = new Date(this.props.calendar_start_date);
      params.yearSel = date.getFullYear();
      params.monthSel = date.getMonth() + 1;
    }

    this.productOptions(product).forEach((option) => {
      params['custom_' + option.key] = option.value.toLowerCase();
    });

    const queryString = UrlBuilder.buildURLQuery(params);
    if (product.action.includes('?')) {
      return product.action + '&' + UrlBuilder.buildURLQuery(params);
    }

    return product.action + '?' + queryString;
  },

  productOptions(product) {
    return product.options.map((option) => {
      const key = option.id,
        value =
          (this.props.options[key] && this.props.options[key].value) ||
          defaultOptionValue(option.options),
        subOption = option.options.find((option) => option.value == value);

      return {
        key,
        value,
        affectsPrice: option.affects_price,
        minimumPrice: subOption.minimum_price,
        priceIsFrom: subOption.price_is_from,
      };
    });
  },
});

export default PriceAndProductCreate;
